import React from 'react';
import { HumanReadableInstallationStage, type InstallationStageName } from '../stages';
import { SelectableFilters, truncateAppliedFilters } from './SelectableFilters';
import { FilterComponentProps } from './types';

type InstallationStageFilterValues = Record<InstallationStageName, boolean>;

const defaultFilters: InstallationStageFilterValues = {
  preWorkForm: false,
  commissioning: false,
  postWorkForm: false,
  certificateOfCompliance: false,
};

function renderValues(value: [string, boolean][]): string {
  return truncateAppliedFilters(
    value.flatMap(([filterKey, filterApplied]) =>
      filterApplied ? [HumanReadableInstallationStage[filterKey as InstallationStageName]] : [],
    ),
  );
}

export const InstallationStageFilters: React.FC<FilterComponentProps> = ({ columnDef, onFilterChanged }) => (
  <SelectableFilters<InstallationStageName, InstallationStageFilterValues>
    columnDef={columnDef}
    defaultFilters={defaultFilters}
    onFilterChanged={onFilterChanged}
    options={Object.entries(HumanReadableInstallationStage)}
    renderValues={renderValues}
  />
);
